import * as amplitude from '@amplitude/analytics-browser'
import { defineVuePlugin } from '#/vue-plugins'

import { client } from '@/shared/api/intranet/client.gen'

export default defineVuePlugin((app) => {
  const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY

  if (!amplitudeApiKey || import.meta.env.DEV) {
    return
  }
  const origin = window.location.origin

  const backendUrl = `${origin}/api`
  const serverUrl = `${backendUrl}/business-metrics/2/httpapi`

  amplitude.init(amplitudeApiKey, {
    serverUrl,
    serverZone: 'EU',
    autocapture: {
      attribution: true,
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
    },
  })

  client.interceptors.request.use(async (request) => {
    const sessionId = amplitude.getSessionId()
    if (sessionId) {
      request.headers.set('X-Session-Id', sessionId.toString())
    }
    return request
  })

  // Provide amplitude globally
  app.provide('amplitude', amplitude)
})
